import axios from "../../../../axiosAuthen";

// get list service
const getListServiceAuthenticate = (header) => {
    return axios({
        url: '/public/list-service-authenticate',
        method: 'GET',
        headers: header
    });
};

// get menu
const getMenuListMenu = async (data, header) => {
    return axios({
        url: '/public/list-menu',
        method: 'GET',
        params: data,
        headers: header
    });
}

// get router
const getListLink = (header) => {
    return axios({
        url: '/public/list-link',
        method: 'GET',
        headers: header
    });
};

// check service
const getCheckDomain = (header) => {
    return axios({
        url: '/public/list-domain',
        method: 'GET',
        headers: header
    });
};

export {
    getListServiceAuthenticate,
    getMenuListMenu,
    getListLink,
    getCheckDomain
};
